export enum ReactCheckout2022_AddressFormTypes {
  shipping = "shipping",
  billing = "billing",
}
export type ReactCheckout2022_AddressFormType =
  `${ReactCheckout2022_AddressFormTypes}`;
